import LoanApplicationIframePageWrapper from 'app/pages/loanApplication/LoanApplicationIframePageWrapper';
import LoanApplicationIframeRedirectPage from 'app/pages/loanApplication/LoanApplicationIframeRedirectPage';

import { PAGE_CODES } from 'constants/pageCodes';
import { EnhancedPath } from 'utils/history';

const LOANS_IFRAME_ROUTING_PARAMS = {
  loanId: 'loanId',
  loanNumber: 'loanNumber',
};

export class LoansIframePaths {
  static loansIframe = new EnhancedPath('/loans-iframe');

  static loan = new EnhancedPath(
    `${LoansIframePaths.loansIframe.path}/:${LOANS_IFRAME_ROUTING_PARAMS.loanId}`,
  );
  static loanByLoanNumber = new EnhancedPath(
    `${LoansIframePaths.loansIframe.path}/:${LOANS_IFRAME_ROUTING_PARAMS.loanNumber}`,
  );

  static loanApplicationManagement = new EnhancedPath(
    `${LoansIframePaths.loan.path}/application/management`,
  );
}

const routesConfig = {
  settings: {
    layout: {
      config: {
        toolbar: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: LoansIframePaths.loanApplicationManagement.path,
      component: LoanApplicationIframePageWrapper,
      pageCode: PAGE_CODES.LOAN_APPLICATION,
      exact: true,
    },
    {
      path: LoansIframePaths.loanByLoanNumber.path,
      component: LoanApplicationIframeRedirectPage,
      pageCode: PAGE_CODES.LOAN_APPLICATION,
      exact: true,
    },
  ],
};

export default routesConfig;
